import React, { useEffect, useState } from 'react'
import { useApp } from '../../helpers/appContext'
import { Section, PaddedContent, withAlertMessages} from 'daymap-library'
import { useAuth } from '../../helpers/authContext';
import Student from '../../components/Student/Student'
import SignInDetails from './RoomSignInDetails'
import {useNavigate, useParams } from 'react-router-dom';

function  RoomSignIn(){
    const { student, mode } = useApp();
    const  [result, setResult]  = useState(null);
    const { lmsFetch } = useAuth();
    const navigate = useNavigate();
    const { roomId } = useParams();

    const signIn = async () => {
        const [signInResult] = lmsFetch(`/lms/api/checkin/SignInStudentRoom?roomID=${roomId}&studentID=${student.ID}`);
        const response = await signInResult();
        setResult(response.data);
      }
    
      useEffect(() => {
        if(!student){ navigate(".."); return; }  
        if(result === null)
          signIn();       
      });

    return (
      <Section>
        <Student {...student} />
        {result === null ? <></> :
          <PaddedContent>
            <SignInDetails {...result}></SignInDetails>
          </PaddedContent>}
      </Section>
    )
}

export default withAlertMessages(RoomSignIn);